import { Injectable } from '@angular/core';
import { QuestionBaseService } from './question-base.service';
import { NumberQuestion, TextQuestion, DateQuestion, QuestionType } from '../models/Question';
import { Demographics } from '../models/demographics';
import { HttpClient } from '@angular/common/http';
import { ScreeningInvite } from '../models/screeningInvite';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicantQuestionService extends QuestionBaseService {

  _applicantData: Demographics;
  public get applicantData(): Demographics {
    if (!this._applicantData) {
      this._applicantData = new Demographics();
    }
    return this._applicantData;
  }


  constructor(private http: HttpClient) {
    super();
    this.tcVerbiage = 'ACKNOWLEDGMENT AND AUTHORIZATION FOR BACKGROUND CHECK – TENANT I acknowledge receipt of the separate document entitled DISCLOSURE REGARDING BACKGROUND INVESTIGATION -- TENANT and A SUMMARY OF YOUR RIGHTS UNDER THE FAIR CREDIT REPORT ACT and certify that I have read and understand both of those documents.  I hereby authorize the obtaining of “consumer reports” and/or “investigative consumer reports” by [the Company] (the “Company”) after receipt of this authorization.  To this end, I hereby authorize, without reservation, any law enforcement agency, administrator, state or federal agency, institution, school or university (public or private), information service bureau, employer,or insurance company to furnish any and all background information requested by Screening One, Inc., 1860 N. Avenida Republica de Cuba, Tampa, FL 33605, (888) 327-6511, www.screeningone.com, another outside organization acting on behalf of the Company and/or Company itself. I agree that a facsimile (“fax”), electronic or photographic copy of this Authorization shall be as valid as the original.New York applicants only:  Upon request, you will be informed whether or not a consumer report was requested by the Company, and if such report was requested, informed of the name and address of the consumer reporting agency that furnished the report.   You have the right to inspect and receive a copy of any investigative consumer report requested by the Company by contacting the consumer reporting agency identified above directly. New York City applicants only: You acknowledge and authorize the Company to provide any notices required by federal, state or local law to you at the address(es) and/or email address(es) you provided to the Company.Washington State residents only:  You also have the right to request from the consumer reporting agency a written summary of your rights and remedies under the Washington Fair Credit Reporting Act.  Minnesota and Oklahoma residents only:  Please check this box if you would like to receive a copy of a consumer report if one is obtained by the Company.I acknowledge receipt of the separate document entitled DISCLOSURE REGARDING BACKGROUND INVESTIGATION -- TENANT and A SUMMARY OF YOUR RIGHTS UNDER THE FAIR CREDIT REPORT ACT and certify that I have read and understand both of those documents.  I hereby authorize the obtaining of “consumer reports” and/or “investigative consumer reports” by [the Company] (the “Company”) after receipt of this authorization.  To this end, I hereby authorize, without reservation, any law enforcement agency, administrator, state or federal agency, institution, school or university (public or private), information service bureau, employer,or insurance company to furnish any and all background information requested by Screening One, Inc., 1860 N. Avenida Republica de Cuba, Tampa, FL 33605, (888) 327-6511, www.screeningone.com, another outside organization acting on behalf of the Company and/or Company itself. I acknowledge receipt of the separate document entitled DISCLOSURE REGARDING BACKGROUND INVESTIGATION -- TENANT and A SUMMARY OF YOUR RIGHTS UNDER THE FAIR CREDIT REPORT ACT and certify that I have read and understand both of those documents.  I hereby authorize the obtaining of “consumer reports” and/or “investigative consumer reports” by [the Company] (the “Company”) after receipt of this authorization.  To this end, I hereby authorize, without reservation, any law enforcement agency, administrator, state or federal agency, institution, school or university (public or private), information service bureau, employer,or insurance company to furnish any and all background information requested by Screening One, Inc., 1860 N. Avenida Republica de Cuba, Tampa, FL 33605, (888) 327-6511, www.screeningone.com, another outside organization acting on behalf of the Company and/or Company itself.'
    this.hasTC = true;
    this.saveUrl = environment.baseURl + '/api/screening';
    // First Name
    this.DataModel = this.applicantData;
    let fn = new TextQuestion();
    fn.name = "FirstName";
    fn.questionOrder = 1;
    fn.questionText = "First Name";
    fn.propertyMapping = "firstName";
    fn.validationMessage = "";
    fn.questionType = QuestionType.Text;

    // Last Name
    let ln = new TextQuestion();
    ln.name = "LastName";
    ln.questionOrder = 2;
    ln.questionText = "Last Name";
    ln.propertyMapping = 'lastName';
    ln.validationMessage = "";
    ln.questionType = QuestionType.Text;

    // Middle Name
    let mn = new TextQuestion();
    mn.name = "MiddleName";
    mn.questionOrder = 3;
    mn.questionText = "Middle Name";
    mn.propertyMapping = "middleName";
    mn.validationMessage = "If you do not have a middle name, please check the box below.";


    // SSN
    let ssn = new TextQuestion();
    ssn.name = "SSN";
    ssn.questionOrder = 4;
    ssn.questionText = "Social Security Number";
    ssn.propertyMapping = "ssn";
    ssn.validationMessage = "";
    ssn.digits = 9;
   

    // DOB
    let dob = new DateQuestion();
    dob.name = "DOB";
    dob.questionOrder = 5;
    dob.questionText = "Date of Birth";
    dob.propertyMapping = "dob";
    dob.validationMessage = "";

    // Monthly Income
    let income = new NumberQuestion();
    income.name = "Income";
    income.questionOrder = 6;
    income.questionText = "Monthly Income";
    income.propertyMapping = "monthlyIncome";
    income.validationMessage = "";

    // Street
    let street = new TextQuestion();
    street.name = "Street";
    street.questionOrder = 7;
    street.questionText = "Street Address";
    street.propertyMapping = "street";
    street.validationMessage = "";

    // City
    let city = new TextQuestion();
    city.name = "City";
    city.questionOrder = 8;
    city.questionText = "City";
    city.propertyMapping = "city";
    city.validationMessage = "";

    // State
    let state = new TextQuestion();
    state.name = "State";
    state.questionOrder = 9;
    state.questionText = "State";
    state.propertyMapping = "state";
    state.validationMessage = "";

    // ZipCode
    let zip = new NumberQuestion();
    zip.name = "ZipCode";
    zip.questionOrder = 10;
    zip.questionText = "Zip Code";
    zip.propertyMapping = "zipCode";
    zip.validationMessage = "";

    this.Questions.push(fn);
    this.Questions.push(ln);
    this.Questions.push(mn);
    this.Questions.push(ssn);
    this.Questions.push(dob);
    this.Questions.push(income);
    this.Questions.push(street);
    this.Questions.push(city);
    this.Questions.push(state);
    this.Questions.push(zip);

    this.currentQuestion = this.Questions[0];
  }

  formatSSN(val: string ): string{
    let len = val.length
    if (len < 4)
        return val
    else if (len  >3 && len < 6)
        return `${val.substr(0, 3)}-${val.substr(3)}`
    else if (len > 5)
            return `${val.substr(0, 3)}-${val.substr(3, 2)}-${val.substr(5, 4)}`
  }

  moveNext(): boolean {
    if (this.currentQuestion.validate() || this.currentQuestion.canFailValidation) {
      this.errorPresent = false;
      this.currentQuestion.errorOnQuestion = false;
      // then we are good and can set this property on the model.
      this.applicantData[this.currentQuestion.propertyMapping] = this.currentQuestion.answer;
      // See if there is a next question to go to
      let candidates = this.Questions.filter((q) => {
        return q.questionOrder == (this.currentQuestion.questionOrder + 1);
      })
      if (candidates.length > 0) {
        this.currentQuestion = candidates[0];
        return true;
      } else {
        this.DataModel = this.applicantData;
        this.questionFlowComplete.next(true);
      }
    }
    else {
      this.errorPresent = true;
      this.currentQuestion.errorOnQuestion = true;
    }
  }

  getInvite(token: string): void {
    this.http.get(environment.baseURl + `/api/screening/invite/${token}`).subscribe((ev: any) => {

      if(ev.redirect != undefined) this.invitefetched.next(ev);
      else{
        this.DataModel.invitation = ev;
        this.invitefetched.next({success : true});
      }

    },
    (err: any)=>{
      console.log('error')
      this.invitefetched.next(err.error);
    });
    // TODO : Error Scenario
  }
}
